import * as ɵngcc0 from '@angular/core';
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * @fileoverview added by tsickle
 * Generated from: index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { AsAverageRating, AsGbp, AsHours, AsPet, Plural, Range } from './pipes/index';
import { ApiUrlService } from './providers/api-url-service';
import { INFRA_CONFIG_TOKEN, InfraConfig, setupInfraConfig } from './providers/config';
import { RequestService } from './providers/request-service';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
/** @type {?} */
var pipes = [AsGbp, Range, AsAverageRating, Plural, AsHours, AsPet];
var HkInfraModule = /** @class */ (function () {
    function HkInfraModule() {
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    HkInfraModule.forRoot = /**
     * @param {?=} config
     * @return {?}
     */
    function (config) {
        if (config === void 0) { config = new InfraConfig(); }
        return {
            ngModule: HkInfraModule,
            providers: [
                { provide: INFRA_CONFIG_TOKEN, useValue: config },
                {
                    provide: InfraConfig,
                    useFactory: setupInfraConfig,
                    deps: [INFRA_CONFIG_TOKEN]
                },
                ApiUrlService,
                RequestService
            ]
        };
    };
HkInfraModule.ɵfac = function HkInfraModule_Factory(t) { return new (t || HkInfraModule)(); };
HkInfraModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HkInfraModule });
HkInfraModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, BrowserModule, HttpClientModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HkInfraModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, BrowserModule, HttpClientModule],
                declarations: __spread(pipes),
                exports: __spread(pipes),
                providers: []
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HkInfraModule, { declarations: function () { return [AsGbp, Range, AsAverageRating, Plural, AsHours, AsPet]; }, imports: function () { return [CommonModule, BrowserModule, HttpClientModule]; }, exports: function () { return [AsGbp, Range, AsAverageRating, Plural, AsHours, AsPet]; } }); })();
    return HkInfraModule;
}());
export { HkInfraModule };

